var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('hr'),_c('center',[_c('strong',[_vm._v("@SUZUYA GROUP,  "+_vm._s(new Date().getFullYear()))])]),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }